import * as PropTypes from 'prop-types';
/**
 * Represents the column group component of the KendoReact ExcelExport component.
 * @returns null
 */
var ExcelExportColumnGroup = function (_) { return null; };
ExcelExportColumnGroup.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.element), PropTypes.element]),
    headerCellOptions: PropTypes.any,
    hidden: PropTypes.bool,
    level: PropTypes.number,
    locked: PropTypes.bool,
    title: PropTypes.string,
    width: PropTypes.number
};
export default ExcelExportColumnGroup;
//# sourceMappingURL=ExcelExportColumnGroup.js.map